module.exports = __webpack_public_path__ + "static/img/pete_pictgrid33_980x856.66e83cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_pictgrid33_980x856.jpg
// module id = cway
// module chunks = 0